module.exports = __webpack_public_path__ + "img/comprovante_imposto_renda.66a806d4.svg";